import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
    Col,
    Row,
    Container,
    Table,
    Pagination,
    PaginationItem,
    PaginationLink,
    ButtonDropdown,
    Dropdown,
    DropdownMenu,
    DropdownToggle,
    DropdownItem,
    Label,
    Badge,
    Card,
    CardTitle,
    CardBody,
    options
} from "reactstrap";
import Select from "react-select";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import mock from "../tables/mock";
import Widget from "../../components/Widget/Widget.js";
import s from "../tables/Tables.module.scss";
import moreIcon from "../../assets/tables/moreIcon.svg";
import Starrating from "../../assets/tables/Start.png";
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns'; // Import the format function from date-fns library
// import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import TimePicker from 'react-bootstrap-time-picker';
import Form from 'react-bootstrap/Form';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BaseAPI from '../../api/apiurl';





const ServiceAdd = function () {

    const [endDate, setEndDate] = useState(null);

    const history = useHistory();


    const handleDateChange2 = (date) => {
        setEndDate(date);
    };

    const options = [
        { value: 'Registered', label: 'Registered' },
        { value: 'Planned', label: 'Planned' },
        { value: 'Assigned', label: 'Assigned' },
        { value: 'Rescheduled', label: 'Rescheduled' }
    ]

    const buttonstyle = {
        display: 'flex',
        alignItems: 'center',
    };

    const handleClickUserview = () => {
        history.push('/timeinlive/service');
    };

    const role = localStorage.getItem('role');


    const isRoleTwo = role === '2';



    const [firstTable] = useState(mock.firstTable);
    const [secondTable] = useState(mock.secondTable);
    const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0); //
    const [tableDropdownOpen, setTableMenuOpen] = useState(false); //
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [staffname, setStaffnam] = useState([]); // staff droupdown
    const [selectedstaff, setSelectedstaff] = useState([]);
    const [projectname, setProject] = useState([]); // project droupdown
    const [selectedproject, setSelectedproject] = useState([]);
    const [location, setLocation] = useState([]); // location droupdown
    const [selectedlocation, setSelectedlocation] = useState([]);
    const [customerId, setCustomerId] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [serivcedDescription, setserivcedDescription] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [diacription, setDiacription] = useState('');
    const [serviceimg, setserviceimg] = useState('');
    const [desireddate, setdesireddate] = useState('');
    // const [optionspriorty, setOptionspriorty] = useState([]);

    const [isChecked, setIsChecked] = useState(false);
    const [VisChecked, setVIsChecked] = useState(false);
    const [custuserid, setcustuserid] = useState(0);
    const [sdate, setSdate] = useState("2023-09-05");
    const [area, setArea] = useState([]); // Area droupdown
    const [selectedarea, setSelectedArea] = useState(null);
    const [AreaKey, setAreaKey] = useState(0);


    const [productList, setProductList] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [locationList, setLocationList] = useState([]);
   

    const getCurrentTime = () => {
        const now = new Date();
        return format(now, 'HH:mm:ss');
      };

      const [selectedTime, setSelectedTime] = useState(getCurrentTime());

    const convertTimeInSecondsToDate = (timeInSeconds) => {
        const timeZoneOffsetMs = new Date().getTimezoneOffset() * 60 * 1000;
        const timeInMs = timeInSeconds * 1000;
        return new Date(timeInMs + timeZoneOffsetMs);
    };
    



    const pageSize = 10;
   

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleTimeChange = (timeInSeconds) => {
        // Calculate the time zone offset in milliseconds
        const timeZoneOffsetMs = new Date().getTimezoneOffset() * 60 * 1000;

        // Calculate the time in milliseconds since midnight
        const timeInMs = timeInSeconds * 1000;

        // Combine the time in milliseconds with the time zone offset
        const selectedTime = new Date(timeInMs + timeZoneOffsetMs);

        // Format the selected time as "HH:mm:ss"
        // const selectedTime = convertTimeInSecondsToDate(timeInSeconds);
        const formattedTime = format(selectedTime, 'HH:mm:ss');



        setSelectedTime(formattedTime); // Set the formatted time to the state
    };

    




    const setSecondTablePage = (e, index) => {
        e.preventDefault();
        setSecondTableCurrentPage(index);
    }

    const tableMenuOpen = () => {
        setTableMenuOpen(!tableDropdownOpen);
    } //

    const optionspriortymodule = [
        { label: "Default", value: "0" },
        { label: "Priority 1", value: "1" },
        { label: "Priority 2", value: "2" },
        { label: "Priority 3", value: "3" },
        { label: "Priority 4", value: "4" },
        { label: "Priority 5", value: "5" }
    ];

    const [optionspriorty, setOptionspriorty] = useState(optionspriortymodule[0]);


    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const vhandleCheckboxChange = () => {
        setVIsChecked(!VisChecked);
    };

    const handleLocationChange = async (value) => {
        try {
            setSelectedlocation(value);
            console.log('Selected Location:', value); // Log the entire value for debugging

            const locationId = value && typeof value === 'object' ? value.value : null;
            console.log('Location ID:', locationId); // Log the locationId for debugging


            if (locationId) {
                setArea([]);
                setSelectedArea(null);

                setAreaKey(prevKey => prevKey + 1);


                await fetchArea(locationId);
            }


            else {
                console.error('Invalid or missing location ID');
            }
        } catch (error) {
            console.error('Error fetching areas:', error);
            // Handle errors if needed
        }
    };

    const handleProjectChange = async (newValue) => {
        setSelectedproject(newValue);

        try {
            const productId = newValue && typeof newValue === 'object' ? newValue.value : null;

            if (productId) {

                setSelectedlocation([]);

                await fetchloaction(productId);
            } else {
                console.error('Invalid or missing project ID');
            }
        } catch (error) {
            console.error('Error fetching tasks:', error);
        }
    };


    const fetchstaff = async () => {
        try {
            const url = `${BaseAPI}servicestaff`;
            const companyId = localStorage.getItem('companyid');
            const customerId = localStorage.getItem('customerid');
            const role = localStorage.getItem('role');
            const Id = localStorage.getItem('id');
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    company_id: companyId,
                    customer_id: customerId,
                    role_id: role,
                    id: Id

                }),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
            
            const data = await response.json();
            const staffList = data.data.map(item => ({ label: item.username, value: item.id }));

            const defaultSelectedStaff = staffList.length > 0 ? staffList[0] : null;
            setStaffnam(staffList);
            setSelectedstaff(defaultSelectedStaff);

        } catch (error) {
            console.error('Error:', error);
            // Handle the error here if needed
        }
    };

    const fetchproduct = async () => {
        try {
            const url = `${BaseAPI}serviceproduct`;
            const companyId = localStorage.getItem('companyid');
            const customerId = localStorage.getItem('customerid');
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    company_id: companyId,
                    customer_id: customerId
                }),
            });
    
            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
    
            const data = await response.json();
            const ProductList = data.data.map(item => ({ label: item.productname, value: item.id }));
    
            const defaultProductList = ProductList.length > 0 ? ProductList[0] : null;
            setProject(ProductList);
            setSelectedproject(defaultProductList);
    
            // Call fetchloaction with the default product ID
            if (defaultProductList) {
                await fetchloaction(defaultProductList.value);
            }
        } catch (error) {
            console.error('Error:', error);
            // Handle the error here if needed
        }
    };
    
    const fetchloaction = async (productId) => {
        try {
            const url = `${BaseAPI}servicelocation`;
            const companyId = localStorage.getItem('companyid');
            const customerId = localStorage.getItem('customerid');
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    company_id: companyId,
                    customer_id: customerId,
                    product_id: productId
                }),
            });
    
            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
    
            const data = await response.json();
            const locations = data.data.map(item => ({ label: item.AssignDesc, value: item.id }));
    
            setLocation(locations);
    
            // Set default location if locations array is not empty
            const defaultLocation = locations.length > 0 ? locations[0] : null;
            setSelectedlocation(defaultLocation);
    
            // Call fetchArea with the default location ID
            if (defaultLocation) {
                await fetchArea(defaultLocation.value);
            }
        } catch (error) {
            console.error('Error:', error);
            // Handle the error here if needed
        }
    };
    

    const fetchArea = async (locationId) => {
        try {
            const url = `${BaseAPI}productareadrop`;
            const companyId = localStorage.getItem('companyid');
            const customerId = localStorage.getItem('customerid');
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    company_id: companyId,
                    customer_id: customerId,
                    location_id: locationId,
                }),
            });
    
            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
    
            const data = await response.json();
            const areas = data.data.map(item => ({ label: item.area, value: item.id }));
    
            setArea(areas);
    
            // Set default area if areas array is not empty
            const defaultArea = areas.length > 0 ? areas[0] : null;
            setSelectedArea(defaultArea);
        } catch (error) {
            console.error('Error:', error);
           
        }
    };
    

    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0]; // Get the selected image file

        if (selectedImage) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const base64Image = event.target.result; // Get the base64-encoded image
                // console.log("Base64 Image:", base64Image);
                setserviceimg(base64Image); // Set the base64 image to the state
            };
            reader.readAsDataURL(selectedImage); // Read the selected image as base64
        }
    }

    const handleSubmit = async () => {
        try {
            const url = `${BaseAPI}serviceadd`;
            const formattedDate = format(selectedDate, 'yyyy-MM-dd'); // Format the date
            // const formattedTime = format(selectedTime, 'HH:mm:ss'); // Format the time
            // console.log('Formatted Time:', formattedTime);
            const desiredDateTime = `${formattedDate} ${selectedTime}`; // Combine date and time


            // console.log('desireddate:', desireddate);
            const formData = new FormData();

            // Append other form fields
            formData.append('company_id', companyId);
            formData.append('customer_id', customerId);
            formData.append('product_id', selectedproject.value);
            formData.append('e_id', selectedstaff.value);
            formData.append('depart_id', selectedlocation.value);
            formData.append('area' , selectedarea.label);
            formData.append('servicedesc', diacription);
            formData.append('serviceimg', serviceimg); // Append the image Blob
            formData.append('desireddate', desiredDateTime);
            formData.append('priority', optionspriorty.value);
            formData.append('charge', isChecked ? 1 : 0);
            formData.append('validate', VisChecked ? 1 : 0);
            formData.append('custuser_id', selectedstaff.value);
            formData.append('serviceRegdate', sdate);



            const response = await fetch(url, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
            const data = await response.json();
            setResponseMessage(data.message);
            toast.success('Data Added Successful!', {
                autoClose: 1500,
                position: 'top-center',
                className: 'custom-toast-success', // Apply the custom error class
            });
            await new Promise((resolve) => setTimeout(resolve, 1500));

            // Navigate to the desired route
            history.push('/timeinlive/service');

        } catch (error) {
            console.error('Error:', error);
            toast.error('Sorry Data Not Added', {       
                autoClose: 1500,
                position: 'top-center',
                className: 'custom-toast-error', // Apply the custom error class
            });
            setResponseMessage('Error occurred while making the API request.');
        }
    };

    React.useEffect(() => {
        // Ensure that selectedTime is set before rendering the TimePicker
        setSelectedTime(getCurrentTime());
    }, []); 

    React.useEffect(() => {
        const customerId = localStorage.getItem('customerid');
        const companyId = localStorage.getItem('companyid');
        if (customerId) {
            setCustomerId(customerId);
        }
        if (companyId) {
            setCompanyId(companyId);
        }
        fetchstaff();
        fetchproduct();
    }, []);


    // console.log("locaton value ", location);


    return (

        <Container fluid>
            <br></br> <br></br>
            <Card >
                <div className="headline-2" style={{ padding: "15px 15px 0px", textAlign: "left", color:"blue" }}> Service Add
                 </div>

                <CardBody style={{ whiteSpace: 'nowrap' }}>
                    <div className="row mt-6">
                        <div className="col-sm-4">
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Request Description</label>
                                <div className="col-sm-10">
                                    <input type="text" className="form-control" id="inputPassword" placeholder="Service description" value={diacription} onChange={(e) => setDiacription(e.target.value)} />
                                </div>
                            </div>
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Select Product</label>
                                <div className="col-sm-10">
                                <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Choose..."
                                        title="Asset Form"
                                        options={projectname}
                                        value={selectedproject}
                                        onChange={handleProjectChange}
                                    />
                            </div>
                            </div>
                           
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Choose Fille</label>
                                <div className="col-sm-10">
                                    <input
                                        className="form-control"
                                        type="file"
                                        id="formFile"
                                        accept="image/*" // Accept only image files
                                        onChange={(e) => handleImageChange(e)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Select User</label>
                                <div className="col-sm-10">
                                    <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Choose..."
                                        title="Asset Form"
                                        options={staffname}
                                        value={selectedstaff}
                                        onChange={(selectedOption) => {
                                            setSelectedstaff(selectedOption ? selectedOption : null);
                                        }}
                                        isDisabled={isRoleTwo}
                                    />

                                </div>
                            </div>
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Select Location</label>
                                <div className="col-sm-10">
                                <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Choose..."
                                        title="Asset Form"
                                        options={location}
                                        value={selectedlocation}
                                        onChange={handleLocationChange}
                                    />
                            </div>
                            </div>

                            <div className="mb-4 row flex-column">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">
                                    Desired Date & Time
                                </label>
                                <div className="col-sm-10">
                                    <div className="d-flex">
                                        <DatePicker
                                            type="text"
                                            className="form-control mr-2"
                                            selected={selectedDate}
                                            onChange={handleDateChange}
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Select a date"
                                        />
                                        <TimePicker
                                            start="00:00"
                                            end="23:59"
                                            step={15}
                                            value={selectedTime}
                                            
                                            onChange={handleTimeChange}
                                        />
                                    </div>
                                </div>
                            </div>
                           
                            {/* <div className="mb-4 row flex-column">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Choose Fille</label>
                                <div className="col-sm-10" >
                                    <input
                                        className="form-control"
                                        type="file"
                                        id="formFile"
                                        accept="image/*" // Accept only image files
                                        onChange={(e) => handleImageChange(e)}
                                    />
                                </div>
                            </div> */}

                        </div>
                        <div className="col-sm-4">
                        <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Priority</label>
                                <div className="col-sm-10">
                                    <div className="cs-form">
                                        <Select
                                            classNamePrefix="select2-selection"
                                            placeholder="Choose..."
                                            title="Asset Form"
                                            options={optionspriortymodule}
                                            value={optionspriorty}
                                            onChange={setOptionspriorty}
                                        />


                                        {/* <TimePicker
        start="00:00"
        end="23:59"
        step={15}
        value={selectedTime}
        onChange={handleTimeChange}
    /> */}
                                    </div>
                                </div>
                            </div>
                            <div className="mb-4 row flex-column  ">
                                <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Select Area</label>
                                <div className="col-sm-10">
                                <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Choose Area..."
                                        title="Asset Form"
                                        options={area}
                                        value={selectedarea}
                                        onChange={setSelectedArea}
                                        key={AreaKey}
                                    />
                            </div>
                            </div>
                            
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <button type="button" onClick={handleClickUserview} className="btn btn-primary" style={{ padding: "5px 20px" }}> <i className="fa fa-window-close" style={{ fontSize: "16px" }} />&nbsp; Cancel</button> &nbsp;&nbsp;
                        <button type="button" className="btn btn-primary" style={{ padding: "5px 10px", }} onClick={handleSubmit}><i className="fa fa-plus-circle" />&nbsp; Submit</button>
                    </div>
                    

                </CardBody>
            </Card>
            &nbsp;  &nbsp;  &nbsp;
            <div>
            </div>
            <ToastContainer />
        </Container>
    )
}

export default ServiceAdd;
